module.exports = __webpack_public_path__ + "static/media/Yahya_Rahimi_Resume.15fc080a.pdf";